<section class="px-xs !py-lg h-full bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Liste des référentiels</h3>
    <div hlmCardAction>
      <button (click)="creerReferentiel()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Créer un référentiel
      </button>
    </div>
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Nom</th>
            <th hlmTh style="min-width: 128px">Type de référentiel</th>
            <th hlmTh style="min-width: 128px">Trigramme métier</th>
            <th hlmTh style="min-width: 128px">Code métier</th>
            <th hlmTh>Statut</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (item of referentiels(); track item.id) {
            <tr hlmTr>
              <td hlmTd>{{ item.nom }}</td>
              <td hlmTd>{{ item.referentielType | convertReferentielTypeToString }}</td>
              <td hlmTd>{{ item.trigrammeMetier }}</td>
              <td hlmTd>{{ item.codeMetier }}</td>
              <td hlmTd>
                <label class="component-medium-medium flex items-center" hlmLabel>
                  <hlm-switch [checked]="item.estActif" (checkedChange)="toggleReferentiel(item)" />
                  {{ item.estActif ? 'Actif' : 'Désactivé' }}
                </label>
              </td>
              <td hlmTd>
                <button
                  (click)="editerReferentiel(item)"
                  aria-label="Éditer le référentiel"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                  hlmTooltipTrigger="Éditer le référentiel"
                >
                  <ng-icon name="lucidePen" />
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <app-paginateur [store]="referentielStore" />
    </div>
  </div>
</section>
